document.querySelectorAll('.swiper-slide .swym-add-to-wishlist-view-product').forEach(button => {
  button.addEventListener('click', () => {
    // クリック時に現在のアクティブ要素からフォーカスを外す
    if (document.activeElement) {
      document.activeElement.blur();
    }
    
    // または、bodyにフォーカスを移す
    document.body.focus();
  });
});

// 商品一覧のバリエーション画像の切り替え
window.setupImageSwitcher = function() {
  
  // #ProductGridContainerまたは.card__variant_chipsが存在するか確認
  if (!document.querySelector('#ProductGridContainer') && !document.querySelector('.card__variant_chips')) return;
  const parentElement = document.querySelector('#ProductGridContainer') || document.querySelector('#MainContent');

  if (parentElement) {
      parentElement.addEventListener('click', function(event) {
          const clickedElement = event.target;

          // クリックされた要素が期待するimgタグであるか確認
          if (clickedElement.tagName === 'IMG' && clickedElement.closest('.card__variant_chips')) {
              const closestCard = clickedElement.closest('.grid__item') || clickedElement.closest('.swiper-slide');
              if (!closestCard) return;

              const mainImage = closestCard.querySelector('.card_media_image ');
              if (mainImage) {
                  mainImage.src = clickedElement.dataset.productimage;
                  mainImage.srcset = clickedElement.dataset.productimage;
              }

              const secondaryImage = closestCard.querySelector('.card_media_image2');
              if (secondaryImage) {
                  secondaryImage.src = clickedElement.dataset.productimage;
                  secondaryImage.srcset = clickedElement.dataset.productimage;
              }

              const allThumbs = closestCard.querySelectorAll('.card__variant_chips img');
              allThumbs.forEach(thumb => thumb.classList.remove('current'));
              clickedElement.classList.add('current');
          }
      });
  }
}
setupImageSwitcher();

// FAQ
var dtElements = document.querySelectorAll('.faqWrap dt');
dtElements.forEach(function(element) {
  element.addEventListener('click', function(event) {
      event.target.classList.toggle('open');
  });
});

// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
        sticky_padding.classList.add('sticky_on');
 		}  else {
  	sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
        sticky_padding.classList.remove('sticky_on');
 	}
	}
	window.addEventListener('scroll', sticky_header_Animation);

  //100ms待機
  setTimeout(sticky_header_Animation, 100);
}

// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}

// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}

// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール
function mousedragscrollable(elements) {
  elements.forEach(function(element) {
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    let scrollTop;

    element.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX - element.offsetLeft;
      startY = e.pageY - element.offsetTop;
      scrollLeft = element.scrollLeft;
      scrollTop = element.scrollTop;
    });

    element.addEventListener('mouseleave', function() {
      isDown = false;
    });

    element.addEventListener('mouseup', function() {
      isDown = false;
    });

    element.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const y = e.pageY - element.offsetTop;
      const walkX = (x - startX) * 1;
      const walkY = (y - startY) * 1;
      element.scrollLeft = scrollLeft - walkX;
      element.scrollTop = scrollTop - walkY;
    });
  });
}

// 商品詳細ページのタブ切り替え
document.addEventListener('DOMContentLoaded', function() {
  const descriptionTab = document.querySelector('.descriptionTab');
  if (descriptionTab) {
    const tabContentA = descriptionTab.querySelector('.tabContent--A');
    const tabContentB = descriptionTab.querySelector('.tabContent--B');
    const tabContainerA = descriptionTab.querySelector('.tab__container.--A');
    const tabContainerB = descriptionTab.querySelector('.tab__container.--B');

    if (tabContentA && tabContainerA) {
      tabContainerA.appendChild(tabContentA);
    }
    if (tabContentB && tabContainerB) {
      tabContainerB.appendChild(tabContentB);
    }

    const tabHeadSpans = descriptionTab.querySelectorAll('.tab__head span');
    tabHeadSpans.forEach((span, index) => {
      span.addEventListener('click', function() {
        tabHeadSpans.forEach(s => s.classList.remove('is-active'));
        this.classList.add('is-active');

        const tabContainers = this.closest('.tab__head').nextElementSibling.children;
        Array.from(tabContainers).forEach((container, i) => {
          if (i === index) {
            container.classList.add('is-active');
          } else {
            container.classList.remove('is-active');
          }
        });
      });
    });
  }
});

// サイドメニュー アコーディオンボタン
document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.accordionButton');
  accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      const content = this.nextElementSibling;
      
      if (isExpanded) {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
        if (this.classList.contains('--only')) {
          accordionButtons.forEach(otherButton => {
            if (otherButton !== this && otherButton.classList.contains('--only')) {
              otherButton.setAttribute('aria-expanded', 'false');
              otherButton.nextElementSibling.style.display = 'none';
            }
          });
        }
      }
    });
  });
});

// header-typeE ナビゲーション 子要素展開
document.addEventListener('DOMContentLoaded', function() {
  const ua = navigator.userAgent;
  const isMobile = (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0 || ua.indexOf('iPad') > 0;

  if (isMobile) {
    const hasChildrenLinks = document.querySelectorAll('.hasChildren > a');
    hasChildrenLinks.forEach(link => {
      link.addEventListener('touchstart', function(e) {
        e.preventDefault();
        this.classList.toggle('open');
        this.nextElementSibling.classList.toggle('open');
      });
    });

    const hasChildrenCloseLinks = document.querySelectorAll('.hasChildren .hasChildren--close > a');
    hasChildrenCloseLinks.forEach(link => {
      link.addEventListener('touchstart', function(e) {
        e.preventDefault();
        this.closest('ul').classList.remove('open');
        this.closest('ul').previousElementSibling.classList.remove('open');
      });
    });
  } else {
    const hasChildren = document.querySelectorAll('.hasChildren');
    hasChildren.forEach(item => {
      item.addEventListener('mouseenter', function() {
        this.querySelector('a').classList.add('open');
        this.querySelector('ul, .megaMenu').classList.add('open');
      });
      item.addEventListener('mouseleave', function() {
        this.querySelector('a').classList.remove('open');
        this.querySelector('ul, .megaMenu').classList.remove('open');
      });
    });
  }
});

// 検索ランキングキーワード
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-header__form input[type="product"]');
  if (searchInput) {
    searchInput.addEventListener('focusin', function() {
      this.closest('.search-header__form').nextElementSibling.classList.add('open');
    });
    searchInput.addEventListener('focusout', function() {
      setTimeout(() => {
        this.closest('.search-header__form').nextElementSibling.classList.remove('open');
      }, 200);
    });
  }
});

// もっと見るボタン
document.addEventListener('DOMContentLoaded', function() {
  const moreBtns = document.querySelectorAll('.js-moreBtn');
  moreBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const contentsBlocks = this.previousElementSibling.classList.contains('contents_blocks') ? 
                             this.previousElementSibling : 
                             this.previousElementSibling.previousElementSibling;
      const keyword = this.previousElementSibling.classList.contains('a-keyword') ? 
                      this.previousElementSibling : 
                      null;
      
      const isActive = contentsBlocks.classList.contains('is-active') || (keyword && keyword.classList.contains('is-active'));

      contentsBlocks.classList.toggle('is-active', !isActive);
      if (keyword) keyword.classList.toggle('is-active', !isActive);

      this.textContent = isActive ? 'もっと見る' : '閉じる';

      if (isActive) {
        const parentSection = this.closest('section');
        //parentSectionまで移動
        parentSection.scrollIntoView({behavior: "smooth", block: "start"});
      }
      
    });
  });
});

// URLパラメータチェック
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const appParam = urlParams.get('app');
  const membershipNumberParam = urlParams.get('membership_number');
  
  const isExcluded = (appParam === '1' || membershipNumberParam);

  if (membershipNumberParam) {
    console.log("membershipあり");
  } else {
    console.log("membershipなし");
  }

  if (urlParams.toString() && isExcluded) {
    document.body.classList.add('param-exists');
  } else {
    document.body.classList.add('param-not-exists');
  }
});

// multiGridマウススクロールの初期化
document.addEventListener('DOMContentLoaded', function() {
  const multiGridElements = document.querySelectorAll('.multiGrid');
  mousedragscrollable(multiGridElements);
});

document.querySelectorAll('form[action="/search"]').forEach(function(form) {
  form.addEventListener('submit', function(event) {
    const searchInput = this.querySelector('input[name="q"]');
    
    if (!searchInput.value.trim()) {
      event.preventDefault();
      alert('検索キーワードを入力してください');
    }
  });
});

//ドロワーメニュー展開
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.menu-drawer__navLink').forEach(function(link) {
    link.addEventListener('click', function() {
      if (this.getAttribute('aria-expanded') === 'false') {
        this.setAttribute('aria-expanded', 'true');
        slideDown(this.nextElementSibling);
      } else {
        this.setAttribute('aria-expanded', 'false');
        slideUp(this.nextElementSibling);
      }
    });
  });
});

// slideDown アニメーション関数
function slideDown(element) {
  element.style.display = 'block';
  element.style.height = '0px';
  const height = element.scrollHeight;
  element.style.transition = 'height 0.3s ease-out';
  element.style.overflow = 'hidden';
  element.style.height = height + 'px';
}

// slideUp アニメーション関数
function slideUp(element) {
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  element.style.transition = 'height 0.3s ease-out';
  element.style.overflow = 'hidden';
  
  setTimeout(() => {
    element.style.height = '0px';
  }, 0);
  
  element.addEventListener('transitionend', function handler() {
    element.style.display = 'none';
    element.style.height = null;
    element.style.transition = null;
    element.style.overflow = null;
    element.removeEventListener('transitionend', handler);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const cartIcon = document.getElementById('cart-icon-bubble');
  const hdBottom = document.getElementById('hd-bottom');
  const originalParent = cartIcon.parentNode;
  
  function moveCartIcon() {
    if (window.innerWidth <= 767) {
      hdBottom.appendChild(cartIcon);
    } else {
      // 親要素の子要素の数を取得
      const childNodes = Array.from(originalParent.children);
      // 最後から2番目の位置に挿入
      const referenceNode = childNodes[childNodes.length - 1];
      originalParent.insertBefore(cartIcon, referenceNode);
    }
  }
  
  // 初期実行
  moveCartIcon();
  
  // ウィンドウリサイズ時に実行
  window.addEventListener('resize', moveCartIcon);
});